import React from 'react'
import './PromoBar.css'

const PromoBar = () => {
  return (
    <div className='promobar'>
        <p>25% OFF EVERYTHING! Sale ends 7/8. Use Code: SAVE25</p>
        {/*<p>15% OFF orders over $75! Use code: SAVE15</p>*/}
    </div>
  )
}

export default PromoBar